var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 6.00018L11.7725 1.32735C12.0757 1.02415 12.0757 0.53218 11.7725 0.227833C11.4693 -0.0765136 10.9773 -0.0753748 10.673 0.227833L6.00018 4.90037L1.32735 0.227833C1.02415 -0.0753748 0.53218 -0.0753748 0.227833 0.227833C-0.0765136 0.531042 -0.0753748 1.02301 0.227833 1.32735L4.90037 6.00018L0.227833 10.673C-0.0753748 10.9762 -0.0753748 11.4682 0.227833 11.7725C0.379295 11.9243 0.578872 12 0.777025 12C0.976316 12 1.17475 11.9243 1.32622 11.7725L6.00018 7.09998L10.673 11.7725C10.8245 11.9243 11.024 12 11.2222 12C11.4203 12 11.6199 11.9243 11.7714 11.7725C12.0746 11.4693 12.0746 10.9773 11.7714 10.673L7.09998 6.00018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3d3ce23cd1498a3ebbd2b119e966f5ba.svg";
export { ForwardRef as ReactComponent };